<template>
  <section>
    <div
      class="flex cursor-pointer items-center justify-between"
      data-testid="filter-header"
      @click="toggle"
    >
      <Headline
        tag="h2"
        size="base"
        :badge="badge"
        class="cursor-pointer tracking-wide"
        data-testid="filter-headline"
        :aria-describedby="badge ? badge : undefined"
        :aria-label="
          badge
            ? `${label}, ${$t('filter.selected_count', { count: badge })}`
            : label
        "
        @click.stop="toggle"
      >
        {{ label }}
        <template #badge="{ badge: number }">
          <span
            v-if="number"
            class="ml-1 rounded-full bg-black px-2 py-1 text-xs leading-3 text-white"
            role="status"
            data-testid="filter-badge"
            :aria-hidden="true"
          >
            <span aria-hidden="true">{{ number }}</span>
          </span>
        </template>
      </Headline>

      <FimButton
        class="hover:bg-transparent"
        no-padding
        type="raw"
        data-testid="filter-toggle-button"
        :aria-expanded="!collapsed"
        :aria-label="`${label} ${collapsed ? $t('filter.expand') : $t('filter.collapse')}`"
        @click.stop="toggle"
      >
        <template #iconAfter>
          <LazyIconFielmannChevronUp
            v-if="collapsed"
            class="size-5"
            aria-hidden="true"
          />
          <LazyIconFielmannChevronDown
            v-else
            key="down"
            class="size-5"
            aria-hidden="true"
          />
        </template>
      </FimButton>
    </div>

    <div v-if="!collapsed" class="mt-2" data-testid="filter-content">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, watchEffect } from 'vue'

defineProps({
  label: {
    type: String as PropType<string>,
    default: '',
  },
  badge: {
    type: Number as PropType<number>,
    default: 0,
  },
})

const collapsed = ref(false)

const toggle = () => {
  collapsed.value = !collapsed.value
}

const emit = defineEmits(['update:collapsed'])
watchEffect(() => emit('update:collapsed', collapsed.value))
</script>
